import {
	AlarmOffOutlined,
	AssignmentTurnedInOutlined,
	CancelPresentationOutlined,
	CancelOutlined,
	DoneAllOutlined,
	FingerprintOutlined,
	HowToRegOutlined,
	PendingActionsOutlined,
	VerifiedOutlined,
} from "@mui/icons-material";
import { Box, Button, ButtonGroup, useTheme } from "@mui/material";

interface IToolbarGridAnalisesProps {
	textButtonPreAprovadas?: string;
	showBotaoPreAprovadas?: boolean;
	onClickPreAprovadas?: () => void;
	selectPreAprovada?: boolean;

	textButtonEmContratacao?: string;
	showBotaoEmContratacao?: boolean;
	onClickEmContratacao?: () => void;
	selectEmContratacao?: boolean;

	textButtonAprovadas?: string;
	showBotaoAprovadas?: boolean;
	onClickAprovadas?: () => void;
	selectAprovada?: boolean;

	textButtonExpiradas?: string;
	showBotaoExpiradas?: boolean;
	onClickExpiradas?: () => void;
	selectExpirada?: boolean;

	textButtonRecusadas?: string;
	showBotaoRecusadas?: boolean;
	onClickRecusadas?: () => void;
	selectRecusada?: boolean;

	textButtonPendentes?: string;
	showBotaoPendentes?: boolean;
	onClickPendentes?: () => void;
	selectPendente?: boolean;

	textButtonBiometria?: string;
	showBotaoBiometria?: boolean;
	onClickBiometria?: () => void;
	selectBiometria?: boolean;

	textButtonTodos?: string;
	showBotaoTodos?: boolean;
	onClickTodos?: () => void;
	selectTodos?: boolean;

	textButtonCancel?: string;
	showBotaoCancel?: boolean;
	onClickCancel?: () => void;
	selectCancel?: boolean;
}

export const ToolbarGridAnalises: React.FC<IToolbarGridAnalisesProps> = ({
	textButtonPreAprovadas = "Pre-Aprovadas",
	showBotaoPreAprovadas = true,
	onClickPreAprovadas,
	selectPreAprovada = false,

	textButtonEmContratacao = "Em contratação",
	showBotaoEmContratacao = true,
	onClickEmContratacao,
	selectEmContratacao = false,

	textButtonAprovadas = "Aprovadas",
	showBotaoAprovadas = true,
	onClickAprovadas,
	selectAprovada = false,

	textButtonExpiradas = "Expiradas",
	showBotaoExpiradas = true,
	onClickExpiradas,
	selectExpirada = false,

	textButtonRecusadas = "Recusadas",
	showBotaoRecusadas = true,
	onClickRecusadas,
	selectRecusada = false,

	textButtonPendentes = "Pendentes",
	showBotaoPendentes = true,
	onClickPendentes,
	selectPendente = false,

	textButtonBiometria = "Biometria",
	showBotaoBiometria = true,
	onClickBiometria,
	selectBiometria = false,

	textButtonTodos = "Todos",
	showBotaoTodos = true,
	onClickTodos,
	selectTodos = true,

	textButtonCancel = "Canceladas",
	showBotaoCancel = true,
	onClickCancel,
	selectCancel = false,
}) => {
	const theme = useTheme();

	return (
		<Box display="flex" alignItems="start" height={theme.spacing(6)}>
			<ButtonGroup aria-label="outlined primary button group">
				{showBotaoTodos && (
					<Button
						color="primary"
						disableElevation
						variant={selectTodos ? "contained" : "outlined"}
						onClick={onClickTodos}
						startIcon={<DoneAllOutlined />}
					>
						{textButtonTodos}
					</Button>
				)}

				{showBotaoPreAprovadas && (
					<Button
						color="primary"
						disableElevation
						variant={selectPreAprovada ? "contained" : "outlined"}
						onClick={onClickPreAprovadas}
						startIcon={<VerifiedOutlined />}
					>
						{textButtonPreAprovadas}
					</Button>
				)}
				{showBotaoEmContratacao && (
					<Button
						color="primary"
						disableElevation
						variant={selectEmContratacao ? "contained" : "outlined"}
						onClick={onClickEmContratacao}
						startIcon={<AssignmentTurnedInOutlined />}
					>
						{textButtonEmContratacao}
					</Button>
				)}
				{showBotaoBiometria && (
					<Button
						color="primary"
						disableElevation
						variant={selectBiometria ? "contained" : "outlined"}
						onClick={onClickBiometria}
						startIcon={<FingerprintOutlined />}
					>
						{textButtonBiometria}
					</Button>
				)}

				{showBotaoAprovadas && (
					<Button
						color="primary"
						disableElevation
						variant={selectAprovada ? "contained" : "outlined"}
						onClick={onClickAprovadas}
						startIcon={<HowToRegOutlined />}
					>
						{textButtonAprovadas}
					</Button>
				)}

				{showBotaoExpiradas && (
					<Button
						color="primary"
						disableElevation
						variant={selectExpirada ? "contained" : "outlined"}
						onClick={onClickExpiradas}
						startIcon={<AlarmOffOutlined />}
					>
						{textButtonExpiradas}
					</Button>
				)}

				{showBotaoRecusadas && (
					<Button
						color="primary"
						disableElevation
						variant={selectRecusada ? "contained" : "outlined"}
						onClick={onClickRecusadas}
						startIcon={<CancelOutlined />}
					>
						{textButtonRecusadas}
					</Button>
				)}

				{showBotaoPendentes && (
					<Button
						color="primary"
						disableElevation
						variant={selectPendente ? "contained" : "outlined"}
						onClick={onClickPendentes}
						startIcon={<PendingActionsOutlined />}
					>
						{textButtonPendentes}
					</Button>
				)}

				{showBotaoCancel && (
					<Button
						color="primary"
						disableElevation
						variant={selectCancel ? "contained" : "outlined"}
						onClick={onClickCancel}
						startIcon={<CancelPresentationOutlined />}
					>
						{textButtonCancel}
					</Button>
				)}
			</ButtonGroup>
		</Box>
	);
};
